import {
  Box,
  TextContent,
  ColumnLayout,
  Button,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { Dispatch, SetStateAction } from "react";

interface ICompanyInfoHeader {
  hasDiffCompany?: boolean;
  setIsModalOpen?: Dispatch<SetStateAction<boolean>>;
}

/**
 * 申請内容照会 事業者タブのヘッダー
 */
export const CompanyInfoHeader = (props: ICompanyInfoHeader) => {
  const { hasDiffCompany, setIsModalOpen } = props;

  /**
   * モーダルを開く.
   */
  const onModalOpen = () => {
    if (setIsModalOpen) {
      setIsModalOpen(true);
    }
  };

  return (
    <Box>
      <Box margin="s" float="left">
        <TextContent>
          <h5>{LABELS.EMPTY_SPACE}</h5>
        </TextContent>
      </Box>
      <ColumnLayout columns={2}>
        <TextContent>
          <h3 style={{ textAlign: "center" }}>{LABELS.CURRENT_INFO}</h3>
        </TextContent>
        <TextContent>
          <h3 style={{ textAlign: "center" }}>
            {LABELS.APPLICATION_INFO}
            {hasDiffCompany && (
              <Button
                iconName="status-info"
                variant="link"
                onClick={onModalOpen}
              />
            )}
          </h3>
        </TextContent>
      </ColumnLayout>
    </Box>
  );
};
